import { useMutationUnarchiveClass } from "api/reactQuery/mutations/classes"
import { useQueryClassesById } from "api/reactQuery/queries/classes"
import { useQueryClient } from "react-query"
import { useNavigate, useParams } from "react-router-dom"
import { RoutePath } from "routes/Route.types"

export const useArchivedClassGuard = () => {
  const { classId } = useParams<{ classId: string }>()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { data: classData } = useQueryClassesById({
    id: Number(classId),
    options: { enabled: !!classId },
  })

  const classInfo = classData?.data
  const isArchived = !!classInfo?.is_archived

  const { mutate: unarchiveClass, isLoading: isRestoring } =
    useMutationUnarchiveClass({
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries("classes")
          queryClient.invalidateQueries("archivedClasses")
          queryClient.invalidateQueries(["classes", Number(classId)])
        },
      },
    })

  const handleRestore = () => {
    if (classId) {
      unarchiveClass({ classId: Number(classId) })
    }
  }

  const handleGoBack = () => {
    navigate(RoutePath.HOMEPAGE, { replace: true })
  }

  const archivedDate = classInfo?.archived_at
    ? new Date(classInfo.archived_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null

  return {
    isClassLoaded: !!classInfo,
    isArchived,
    isRestoring,
    className: classInfo?.name ?? "",
    archivedDate,
    handleRestore,
    handleGoBack,
  }
}
